import React, { useState } from 'react';
import logo from '../../images/logo.png';
import './Profile.css';
import { Link as Anchor } from 'react-router-dom';
import ShareWeb from '../ShareWeb/ShareWeb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import { useTiendaPrincipal } from '../storeData';
import Swal from 'sweetalert2';

export default function Profile({ installPrompt }) {
    const { tienda } = useTiendaPrincipal();
    const [installing, setInstalling] = useState(false);
    const showInstallButton = installPrompt?.canInstall ||
        (installPrompt?.isIos && !installPrompt?.isInstalled);

    const handleInstallClick = async () => {
        if (installPrompt?.canInstall) {
            setInstalling(true);
            try {
                await installPrompt.installApp();
            } finally {
                setInstalling(false);
            }
            return;
        }

        if (installPrompt?.isIos) {
            Swal.fire({
                title: 'Instalar app',
                html: 'En iPhone abre esta web desde Safari, toca el boton de compartir y elige <b>Agregar a pantalla de inicio</b>.',
                icon: 'info',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#8a2be2',
            });
        }
    };

    return (
        <div className='profileContain'>
            {tienda?.imagen1 ? (
                <img src={tienda.imagen1} alt="logo" />
            ) : (
                <img src={logo} alt="logo" />
            )}

            {tienda?.nombre && <h2>{tienda.nombre}</h2>}

            <div className='profileText'>
                {tienda?.eslogan && <p>{tienda.eslogan}</p>}

                <Anchor to={`/productos`} >
                    <FontAwesomeIcon icon={faShoppingBag} />
                    <span>Todos Los Productos</span>
                </Anchor>

                {showInstallButton && (
                    <button
                        type='button'
                        className='profileInstallApp'
                        onClick={handleInstallClick}
                        disabled={installing}
                    >
                        <FontAwesomeIcon icon={faDownload} />
                        <span>{installing ? 'Abriendo instalador' : 'Instalar app'}</span>
                    </button>
                )}

                {tienda?.direccion && (
                    <Anchor to={`http://maps.google.com/?q=${encodeURIComponent(tienda.direccion)}`} target="_blank">
                        {tienda.direccion}
                    </Anchor>
                )}

                <div className='socials'>
                    {tienda?.instagram && <Anchor to={tienda.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>}
                    {tienda?.telefono && <Anchor to={`https://wa.me/${tienda.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>}
                    {tienda?.facebook && <Anchor to={tienda.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>}
                </div>
            </div>

            <ShareWeb />
        </div>
    );
}
